export const props = {
  text: String
}
